import { t } from 'i18next';

import { OpRawMenuItemType } from 'config/createRawMenuItems';
import { HomeOutlinedSvg } from 'components/svgs/HomeOutlinedSvg/HomeOutlinedSvg';
import { HomeFilledSvg } from 'components/svgs/HomeFilledSvg/HomeFilledSvg';
import { LocationOutlinedSvg } from 'components/svgs/LocationOutlinedSvg/LocationOutlinedSvg';
import { AdminOutlinedSvg } from 'components/svgs/AdminOutlinedSvg/AdminOutlinedSvg';
import { AdminFilledSvg } from 'components/svgs/AdminFilledSvg/AdminFilledSvg';
import { CameraOutlinedSvg } from 'components/svgs/CameraOutlinedSvg/CameraOutlinedSvg';

import {
  sosHomeRoute,
  sosSitesRoute,
  sosAdminRoute,
  sosCamerasRoute,
} from './routes';

export const sosHomeMenuItem = (): OpRawMenuItemType => ({
  key: sosHomeRoute,
  title: t('Home'),
  route: sosHomeRoute,
  icon: <HomeOutlinedSvg />,
  selectedIcon: <HomeFilledSvg />,
  scope: ['o{orgId}-sos:w', 'o:w'],
});

export const sosSitesMenuItem = (): OpRawMenuItemType => ({
  key: sosSitesRoute,
  title: t('Sites'),
  route: sosSitesRoute,
  icon: <LocationOutlinedSvg />,
  selectedIcon: <LocationOutlinedSvg />,
  scope: ['o{orgId}-sos:w', 'o:w'],
});

export const sosCamerasMenuItem = (): OpRawMenuItemType => ({
  key: sosCamerasRoute,
  title: t('Cameras'),
  route: sosCamerasRoute,
  icon: <CameraOutlinedSvg />,
  selectedIcon: <CameraOutlinedSvg />,
  scope: ['o{orgId}-sos:w', 'o:w'],
});

export const sosAdminMenuItem = (): OpRawMenuItemType => ({
  key: sosAdminRoute,
  title: t('Admin'),
  route: sosAdminRoute,
  icon: <AdminOutlinedSvg />,
  selectedIcon: <AdminFilledSvg />,
  scope: ['o{orgId}-sos:w', 'o:w'],
});

export const sidebarItems = (): OpRawMenuItemType[] => [
  sosHomeMenuItem(),
  sosSitesMenuItem(),
  sosCamerasMenuItem(),
  sosAdminMenuItem(),
];
